export const SYNODIC_MONTH_DAYS = 29.5;
export const EARTH_AXIAL_TILT_DEGREES = 23.44;
export const LUNAR_ORBIT_INCLINATION_DEGREES = 5.1;
export const REPRESENTATIVE_NODE_LONGITUDE_DEGREES = 32;
export const MOON_ORBIT_RADIUS = 8;
export const EARTH_RADIUS = 1.35;
export const MOON_RADIUS = 0.48;
export const ORBIT_SECONDS_AT_ONE_X = 59;
export const EARTH_ROTATION_SECONDS_AT_ONE_X = 2;
export const INITIAL_LUNAR_DAY = SYNODIC_MONTH_DAYS / 4;
export const SUNLIGHT_TRAVEL_DIRECTION = [1, 0, 0] as const;
